export default __webpack_public_path__ + "static/media/secretary.05e27418.png";